/**
 * Runtime configuration, read from the `nlocal-config` meta tag the Blade shell renders.
 *
 * Deliberately not `import.meta.env`: Vite inlines those at build time, so a single built
 * bundle could not be promoted from staging to production without rebuilding. Reading from
 * the server-rendered document means the same `public/build` artifact runs anywhere.
 */
export interface ReverbConfig {
  key: string
  host: string
  port: number
  scheme: 'http' | 'https'
}

export interface AppConfig {
  appName: string
  /** Origin the API is served from. Same origin as the SPA — see DECISIONS.md D-009. */
  apiUrl: string
  docsUrl: string
  reverb: ReverbConfig
}

const FALLBACK: AppConfig = {
  appName: 'nlocal',
  apiUrl: window.location.origin,
  docsUrl: 'https://nlocal.dev/docs',
  reverb: { key: '', host: window.location.hostname, port: 8080, scheme: 'http' },
}

function read(): AppConfig {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="nlocal-config"]')

  if (meta === null) return FALLBACK

  try {
    return { ...FALLBACK, ...(JSON.parse(meta.content) as Partial<AppConfig>) }
  } catch {
    // A malformed tag must not take the whole dashboard down; same-origin defaults work.
    return FALLBACK
  }
}

export const config: AppConfig = read()
